import React from "react";
import { Helmet } from "react-helmet-async";
import {
  Hero,
  InfoGraph,
  HeadingSection,
  Carousel,
} from "../components/technology";
import MilaFeeds from "../components/landing-refresh/MilaFeeds";
import AirInsights from "../components/landing-refresh/AirInsights";
import { airInsightsStatic } from "../static-data/LandingRefresh/airInsightsStatic";
import { graphStatic } from "../static-data/technology/graphStatic";
import { carouselStatic } from "../static-data/technology/carousel";

/**
 * @param {Object} props
 * @return {JSX.Element}
 * @constructor
 */

const Technology = ({ route }) => {
  return (
    <>
      <Helmet>
        <title>{route?.meta?.title}</title>
      </Helmet>
      <Hero />
      <AirInsights
        className="air-insights--technology"
        data={airInsightsStatic}
      />
      <InfoGraph graphs={graphStatic} />
      <HeadingSection
        title={
          "It’s no wonder 86% of customers say <br /> they know more about their air quality within the first seven days."
        }
      />
      <HeadingSection
        title={"Mila is more than metrics— <br /> she’s thoughtful, too."}
        className="heading-section--secondary"
      />
      <Carousel carouselData={carouselStatic} />
      <HeadingSection
        title={
          "<em>It's no wonder Mila was a 2024 Webby Award Nominee for Best Connected Product.</em>"
        }
      />
      <MilaFeeds />
    </>
  );
};

export default { component: Technology };
